/**
 * Where your misses live laterally. Each miss contributes a signed offset
 * (ring.x - ship.x). Histogram rendered as a tiny SVG bar chart.
 *
 * 15 bins across the spawn range (-10..+10). Older entries fall off when
 * the cap is reached.
 */

const KEY = "aether.miss_lateral";
const MAX = 200;
const BINS = 15;
const RANGE = 10; // matches ring lateral spawn range

export function recordMiss(lateralSigned: number) {
  try {
    const list = load();
    list.push(Math.max(-RANGE, Math.min(RANGE, lateralSigned)));
    while (list.length > MAX) list.shift();
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* quota */
  }
}

export function load(): number[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((n) => typeof n === "number") : [];
  } catch {
    return [];
  }
}

export function renderHeatmap(w = 220, h = 32): string {
  const values = load();
  if (values.length < 3) {
    return `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" aria-hidden="true"></svg>`;
  }
  const counts = new Array(BINS).fill(0);
  for (const v of values) {
    const t = (v + RANGE) / (RANGE * 2);
    const i = Math.max(0, Math.min(BINS - 1, Math.floor(t * BINS)));
    counts[i] += 1;
  }
  const max = Math.max(...counts) || 1;
  const barW = w / BINS;
  const bars = counts
    .map((c, i) => {
      const x = i * barW;
      const bh = (c / max) * (h - 2);
      const y = h - bh;
      const opacity = (c / max) * 0.95 + 0.05;
      return `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${(barW - 1).toFixed(1)}" height="${bh.toFixed(1)}" fill="currentColor" opacity="${opacity.toFixed(2)}" />`;
    })
    .join("");
  // Center dotted line so player sees their own zero
  const cx = w / 2;
  return `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" aria-hidden="true">
    ${bars}
    <line x1="${cx}" y1="0" x2="${cx}" y2="${h}" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2 2" opacity="0.35" />
  </svg>`;
}
